export default __webpack_public_path__ + "static/media/drinks.3253a33f.png";